module.exports = __webpack_public_path__ + "img/Group 2@2x.9d9a6f8c.png";